import useDemoHelper from "./useDemoHelper";
import step21 from "../../../../../assets/demo/emergency/2.1.mp3";
import step22 from "../../../../../assets/demo/emergency/2.2.mp3";
import step23 from "../../../../../assets/demo/emergency/2.3.mp3";

window.sound = new Audio();

export default function () {
    const demoHelper = useDemoHelper();

    const flashAppointment = () => {
        demoHelper.flash('[data-test="notify-appointment"]', 3);
    }

    const flashGps = () => {
        const openMapButton = document.querySelector('[data-test="button-open-map"]');

        demoHelper.flash(openMapButton, 5);
    }

    const flashClientPhone = async () => {
        demoHelper.flash('[data-test="button-menu"]', 2);

        await demoHelper.sleep(2000);

        demoHelper.click('[data-test="button-menu"]');

        await demoHelper.sleep(500);

        demoHelper.flash(document.querySelector('[data-test="menu-call-beneficiary"]'), 5);

        await demoHelper.sleep(5500);

        document.getElementsByClassName('MuiModal-backdrop')[0].click();
    }


    return {
        async launch(audio = true, visual = true) {
            demoHelper.lockInteract();

            // 16 seconds
            window.sound.src = step21;
            window.sound.play();

            await demoHelper.sleep(6000);
            flashAppointment();

            await demoHelper.sleep(4000);
            flashGps();

            await demoHelper.sleep(7000);

            // 7 seconds
            window.sound.src = step22;
            window.sound.play();

            await demoHelper.sleep(2000);

            await flashClientPhone();

            await demoHelper.sleep(1000);

            // 4 seconds
            window.sound.src = step23;
            window.sound.play();

            await demoHelper.sleep(3000);

            demoHelper.unlockInteract();
        }
    }
}